import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@/ui/button/Button";
import style from "./SkipButton.module.css";

function SkipButton({ dispatch, index, questions }) {
	const { t } = useTranslation();
	const handleClick = () => {
		let actionType;
		if (index < questions.length - 1) {
			actionType = "nextQuestion";
		} else if (index === questions.length - 1) {
			actionType = "finish";
		} else {
			actionType = "restart";
		}
		dispatch({ type: actionType });
	};

	return (
		<Button className={style.skip} onClick={handleClick}>
			{index >= questions.length
				? t("quiz:skip.restart")
				: t("quiz:skip.skip")}
		</Button>
	);
}

export default SkipButton;
